import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DatabaseService } from 'src/_services/DatabaseService';
import { DialogComponent } from '../dialog.component';
import { ImageModuleComponent } from '../image-module/image-module.component';
import { sessionStorage } from '../localstorage.service';
import { CheckindocumentComponent } from '../checkindocument/checkindocument.component';
import { AttendancemodalComponent } from '../attendancemodal/attendancemodal.component';

@Component({
  selector: 'app-attendance-detail',
  templateUrl: './attendance-detail.component.html'

})
export class AttendanceDetailComponent implements OnInit {
  skLoading: boolean = false;
  attendance_data: any = {};
  checkin_data: any = [];
  url: any;
  assign_login_data2: any = {};
  editStartTime: boolean = false;
  editStopTime: boolean = false;
  imageData: any = [];
  header: any = [];
  waypoints = [];
  dataArray = [];
  location: any = [];
  origin: any;
  destination: any;
  lat: any;
  lng: any;
  url1: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data, public dialogs: MatDialog, public toast: ToastrManager, public service: DatabaseService, public session: sessionStorage, public dialog: DialogComponent, public dialogRef: MatDialogRef<AttendanceDetailComponent>)
   {

console.log(data);




    if (data.from != 'attendence_images') {
      this.getDetails();
      this.getDirection();
    }


    if (data.from == 'attendence_images') {
      this.imageData = data.images_data;
      console.log( this.imageData,' this.imageData');


      for (let index = 0; index <  data.images_data.length; index++) {
        if(data.images_data[index]['data'].length>0)
        {
          this.dataArray.push(data.images_data[index]['data'])
        }

      }
       console.log('datarray',this.dataArray)
      this.header=data.header;
      console.log(this.header);


    }
    console.log(data,'data remaing');
    // missingImages.forEach(userId => {
    //   let index = data.user_id.indexOf(userId);
    //   if (index !== -1) {
    //     data.user_id.splice(index, 1);
    //   }
    // });



  console.log(this.header.module);
  let replaceUrl=''
  if(this.attendance_data.startMeterImage ||this.attendance_data.stopMeterImage){
    console.log(this.attendance_data.startMeterImage);
    console.log(this.attendance_data.stopMeterImage);
    replaceUrl='meter_image/'
  }
  if(this.header.module=='Attendance'){
    replaceUrl='attendence/'
  }
  else if(this.header.module=='Checkin'){
    replaceUrl='checkin/'
  }
  else if(this.header.module=='Checkin'){
    replaceUrl='checkin/'
  }
  else if(this.header.module=='Expesne'){
    replaceUrl='expense/'
  }
  else if(this.header.module=='Event'){
    replaceUrl='event_file/'
  }
   else if(this.header.module=='Leave'){
    replaceUrl='Leave/'
  }
else{
  replaceUrl='attendence/'
}


    this.url = this.service.uploadUrl + replaceUrl;
    this.url1 = this.service.uploadUrl + 'meter_image/';
    console.log(this.url1);


    this.assign_login_data2 = this.session.getSession();

    this.assign_login_data2 = this.assign_login_data2.value;
    this.assign_login_data2 = this.assign_login_data2.data;
    this.filterData();
  }

  filterData() {
      if (this.data.images_data) {
        this.data.images_data = this.data.images_data.filter(imageData => {
          return imageData.id !== undefined && imageData.image !== undefined;
        });

        console.log('Filtered image data:', this.data.images_data);
      } else {
        console.error('Data or images_data is undefined');
      }
      console.log('Remaining user data:', this.data);
      console.log('Remaining user data:', this.data.image_data);
  }


  attendancAbsent() {
    const dialogRef = this.dialogs.open(AttendancemodalComponent, {
      width: '500px',
      panelClass: 'cs-modal',
      data: {
        'date':this.data.date,
        'attendance_id':this.data.attendance_id,
        'user_id':this.data.user_id,
        'from': 'attendance_mark',
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    this.dialogRef.close();

    });
  }


  ngOnInit() {

    this.service.currentUserID = this.data.attendance_id
  }

  close() {
    this.dialogRef.close();
  }

  getDetails() {
    console.log('data is ',this.data)
    this.skLoading = true;
    this.service.post_rqst({ 'attendance_id': this.data.attendance_id, 'user_id': this.data.user_id, 'date': this.data.date }, "Attendance/attendenceForTravelDetail")
      .subscribe((result => {
        if (result['statusCode'] == 200) {
          this.attendance_data = result['result'];
          this.checkin_data = this.attendance_data['check_in_data'];
          this.location = this.attendance_data['latlngArray'];

          if (this.attendance_data.counter_time > 60) {
            this.roundNumber(this.attendance_data.counter_time, '')
          }
          if (this.location.length > 0) {
            for (let i = 0; i < this.location.length; i++) {
              this.waypoints.push({ 'location': { 'lat': this.location[i]['lat'], 'lng': this.location[i]['lng'], }, 'stopover': false });
            }
          }
          if (this.attendance_data.start_lat && this.attendance_data.start_lng) {
            this.lat = this.attendance_data.start_lat;
            this.lng = this.attendance_data.start_lng;
            this.origin = { 'lat': this.attendance_data.start_lat, 'lng': this.attendance_data.start_lng };
          }
          if (this.attendance_data.stop_lat && this.attendance_data.stop_lng) {
            this.destination = { 'lat': this.attendance_data.stop_lat, 'lng': this.attendance_data.stop_lng };
          }
          else {
            this.destination = { 'lat': this.location[this.location.length - 1]['lat'], 'lng': this.location[this.location.length - 1]['lng'] };
          }
          this.skLoading = false;

        } else {
          this.toast.errorToastr(result['statusMsg'])
          this.skLoading = false;
        }
      }))
  }


  roundNumber(num, places) {
    return Math.round(num * Math.pow(10, places)) / Math.pow(10, places);
  }

  goToImage(image) {
    const dialogRef = this.dialogs.open(ImageModuleComponent, {
      panelClass: 'Image-modal',
      data: {
        'image': image,
        'type': 'base64'
      }
    });
    dialogRef.afterClosed().subscribe(result => {

    });

  }

  getDirection() {
    this.origin = { lat: this.attendance_data.start_lat, lng: this.attendance_data.start_lng };
    this.destination = { lat: this.attendance_data.stop_lat, lng: this.attendance_data.stop_lng };
  }
  markerOptions = {
    origin: {
      infoWindow: 'Origin.',
      // label:'Start',
      icon: './assets/location/start_point.png',
    },
    waypoints: [
      {
        // infoWindow: `<h4>Crowne Plaza New Delhi Mayur Vihar Noida, an IHG Hotel<h4>
        // <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
        // <a href='http://google.com' target='_blank'>Aaa</a>
        // `,
        // label:'KEI Wires',
        icon: './assets/location/checkin_point.png'
      }, {
        icon: './assets/location/checkin_point.png'
      },
      {
        icon: './assets/location/checkin_point.png'
      },
      {
        icon: './assets/location/checkin_point.png'
      },
      {
        icon: './assets/location/checkin_point.png'
      },
      {
        icon: './assets/location/checkin_point.png'
      },
      {
        icon: './assets/location/checkin_point.png'
      },
      {
        icon: './assets/location/checkin_point.png'
      },
      {
        icon: './assets/location/checkin_point.png'
      },
      {
        icon: './assets/location/checkin_point.png'
      },
      {
        icon: './assets/location/checkin_point.png'
      },
      {
        icon: './assets/location/checkin_point.png'
      },
      {
        icon: './assets/location/checkin_point.png'
      },
      {
        icon: './assets/location/checkin_point.png'
      },
      {
        icon: './assets/location/checkin_point.png'
      },
      {
        icon: './assets/location/checkin_point.png'
      }



    ],
    destination: {
      infoWindow: 'Destination',
      icon: './assets/location/end_point.png',
    },
  };
  markAbsent(attenData) {
    this.dialog.confirm("You Want To  Mark Absent !").then((result) => {
      if (result) {
        this.service.post_rqst({ 'id': attenData.id, 'manual_absent': attenData.manual_absent }, "Attendance/markAbsent")
          .subscribe(resp => {
            if (resp['statusCode'] == 200) {
              this.toast.successToastr(resp['statusMsg']);
              this.getDetails()
            }
            else {
              this.toast.errorToastr(resp['statusMsg']);
            }
          });
      }
    })
  }

  saveNewStartTime(action) {
    let attendanceData = {}
    let msg = '';
    if (action == 'editStartTime') {
      attendanceData = {
        'type': 'start_time',
        'start_time': this.attendance_data.start_time,
        'updated_by_id': this.assign_login_data2.id,
        'updated_by_name': this.assign_login_data2.name
      }
      msg = "You Want To  Start Attendence !"
    } else {
      attendanceData = {
        'type': 'stop_time',
        'stop_time': this.attendance_data.stop_time,
        'updated_by_id': this.assign_login_data2.id,
        'updated_by_name': this.assign_login_data2.name
      }
      msg = "You Want To  Stop Attendence !"
    }

    this.dialog.confirm(msg).then((result) => {
      if (result) {
        this.service.post_rqst({ 'id': this.attendance_data.id, attendanceData }, "Attendance/editAttendenceTime")
          .subscribe(resp => {
            if (resp['statusCode'] == 200) {
              this.toast.successToastr(resp['statusMsg']);
              this.getDetails()
            }
            else {
              this.toast.errorToastr(resp['statusMsg']);
            }
          });
      }
    });
    this.editStartTime = false;
    this.editStopTime = false;
  }

  opendoc(list) {

    const dialogRef = this.dialogs.open(CheckindocumentComponent, {
      width: '768px',
      data: {
        list: [{ 'doc': list }]
      }
    });
    dialogRef.afterClosed().subscribe(result => {

    });

  }


}
